module.exports = __webpack_public_path__ + "img/jigsaw-option-4.3539ec17.png";